import styled from 'styled-components';
import { Row, Column } from 'components/shared/Layout';

import { fonts } from 'themes/default';

export const StyledHeaderRow = styled(Row)`
  ${fonts.BodyMBold}
`;

export const StyledCell = styled(Column)`
  min-width: 0;
  overflow-wrap: break-word;
`;
